import * as React from 'react';

function SvgNbaTab(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={40} height={30} {...props}>
      <defs>
        <style>{`.nba_tab_svg__prefix__cls-2{fill:${props.fill}`}</style>
      </defs>
      <g id="nba_tab_svg__prefix__nba_tab" transform="translate(-288 -97)">
        <path
          id="nba_tab_svg__prefix__Rectangle_2038"
          d="M0 0h40v30H0z"
          data-name="Rectangle 2038"
          transform="translate(288 97)"
          fill="none"
        />
        <g
          id="nba_tab_svg__prefix__basketball_1_"
          data-name="basketball (1)"
          transform="translate(267.992 97)"
        >
          <path
            id="nba_tab_svg__prefix__Path_5464"
            d="M426.58 221.145a.572.572 0 10-.572-.572.573.573 0 00.572.572z"
            className="nba_tab_svg__prefix__cls-2"
            data-name="Path 5464"
            transform="translate(-377.105 -207.408)"
          />
          <path
            id="nba_tab_svg__prefix__Path_5465"
            d="M26.008 2.862v12.592a1.719 1.719 0 001.717 1.717h2.388a1.72 1.72 0 001.619 1.145h.159a24.635 24.635 0 011.041 5.47 26.059 26.059 0 01-.051 4.884.573.573 0 00.945.495l2.5-2.179 2.472 2.178a.572.572 0 00.757 0l2.472-2.178 2.5 2.179a.573.573 0 00.945-.494 26.12 26.12 0 01-.05-4.884 24.763 24.763 0 011.04-5.47h.158a1.718 1.718 0 001.62-1.145h2.38a1.719 1.719 0 001.717-1.717V2.862a1.719 1.719 0 00-1.717-1.717h-7.651a6.866 6.866 0 00-7.592 0h-7.652a1.719 1.719 0 00-1.717 1.717zm7.8 18.6q-.166-1.035-.4-2l1.368 1.194zm.246 2q-.029-.33-.066-.658l1.661-1.38 2.651 2.314-1.976 1.725zm2.487-2.779l2.635-2.19 2.636 2.19-2.636 2.3zm6.163.741l1.66 1.38c-.024.217-.046.438-.066.659l-2.275 2-1.976-1.725zm1.842.042l-.968-.8 1.369-1.194q-.24.952-.405 1.989zm-1.86-1.546l-1.925-1.6h3.758zm-7.018 0l-1.833-1.6h3.758zm-1.533 7.462c.038-.75.045-1.525.019-2.308l1.306 1.151zm5.042.592l-1.98-1.745 1.98-1.728 1.98 1.728zm5.023-2.9c-.026.783-.019 1.558.019 2.308l-1.326-1.157zm2.417-7.9H31.732a.572.572 0 110-1.145h14.881a.572.572 0 110 1.145zm4.575-14.312v12.592a.573.573 0 01-.572.572h-2.388a1.72 1.72 0 00-1.619-1.145H31.732a1.718 1.718 0 00-1.62 1.145h-2.387a.573.573 0 01-.572-.572V2.862a.574.574 0 01.572-.573h6.329a6.868 6.868 0 00-.2 8.932l.005.007a6.869 6.869 0 0010.614 0l.006-.008a6.867 6.867 0 00-.2-8.931h6.341a.573.573 0 01.572.573zM44.866 6.3h-1.657a5.74 5.74 0 01.829-2.442 5.741 5.741 0 01.828 2.442zm-9.819 4.54a6.888 6.888 0 001.239-3.4H38.6v5.122a5.7 5.7 0 01-3.553-1.726zm-.74-6.982a5.74 5.74 0 01.829 2.442h-1.657a5.74 5.74 0 01.828-2.446zm.829 3.587a5.743 5.743 0 01-.829 2.442 5.742 5.742 0 01-.829-2.442zm4.609 0h2.314a6.887 6.887 0 001.239 3.4 5.7 5.7 0 01-3.553 1.727zm4.293 2.442a5.745 5.745 0 01-.829-2.443h1.657a5.743 5.743 0 01-.828 2.439zm-1.574-7.7a5.735 5.735 0 01.836.713 6.885 6.885 0 00-1.241 3.4h-2.314V1.174a5.674 5.674 0 012.719 1.011zM38.6 6.3h-2.314a6.885 6.885 0 00-1.238-3.4 5.736 5.736 0 01.834-.717A5.674 5.674 0 0138.6 1.174z"
            className="nba_tab_svg__prefix__cls-2"
            data-name="Path 5465"
          />
          <path
            id="nba_tab_svg__prefix__Path_5466"
            d="M426.58 86.868a.572.572 0 00.572-.572v-5.724a.572.572 0 00-1.145 0V86.3a.572.572 0 00.573.568z"
            className="nba_tab_svg__prefix__cls-2"
            data-name="Path 5466"
            transform="translate(-377.105 -75.421)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgNbaTab;
